// 引入文件
const apilist = require.context('./', true, /\.api.js$/);
let apiObj = {};
apilist.keys().forEach((fileName) => {
    // 组件
    const config = apilist(fileName);
    apiObj = Object.assign(apiObj, config.default);
});
export default { ...apiObj };
